import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Message, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {Alert} from 'componentLibrary';
class MessagesAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
    };
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.status === this.props.fromState &&
      this.props.status === this.props.toState &&
      prevProps.entityId === this.props.entityId
    ) {
      this.setState({
        message: this.props.message,
      });
    }
  }
  render() {
    const {message} = this.state;
    return (
      <React.Fragment>
        {!_.isEmpty(message) && <Alert header={message} type="success" dismissable />}
      </React.Fragment>
    );
  }
}
export const mapStateToProps = (state, props) => {
  return {
    message: _.get(state, 'messages.messages'),
    status: _.get(state, 'dynamicComponent.data.status'),
    entityId: _.get(state, 'dynamicComponent.data.entityId'),
  };
};
export default connect(mapStateToProps)(MessagesAlert);
